import React from 'react';

const SvgCircleLegend = (props) => (
  <svg width={20} height={10} {...props}>
    <g fill="none">
      <rect width={20} height={1} y={4.333} fill={props.color} rx={0.5} />
      <circle
        cx={10}
        cy={5}
        r={4}
        fill="#FFF"
        stroke={props.color}
        strokeWidth={2}
      />
    </g>
  </svg>
);

export default SvgCircleLegend;
